import React, {Component, ChangeEvent, ReactNode} from "react"

import id from "@irati/utils/id"
import {Option, OptionRow} from "./Radio"
import defaultRenderer from "./RowRenderers"
import {RadioInput, RadioOptionLabel} from "./styled"

interface Props {
  id: string,
  name: string,
  onChange: (newValueIndex: number) => void,
  option: Option,
  value: number,
  checked: boolean,
  inline: boolean,
  disabled: boolean,
  className?: string,
  rowRenderer?: (optionRow: OptionRow) => ReactNode
}
interface State {}

class RadioOption extends Component<Props, State> {
  handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    this.props.onChange(parseInt(e.currentTarget.value, 10))
  }

  render() {
    const {option, value, disabled, checked, className, inline, rowRenderer, name} = this.props
    const idNamespace = id("Radio", this.props)

    return (
      <RadioOptionLabel id={id("Label", idNamespace)} htmlFor={idNamespace} className={className} inline={inline}>
        <RadioInput
          id={idNamespace}
          name={name}
          checked={checked}
          value={value}
          disabled={disabled}
          type="radio"
          onChange={this.handleChange} />
        {rowRenderer && rowRenderer({option, disabled, checked})}
        {!rowRenderer && defaultRenderer({option, disabled, checked})}
      </RadioOptionLabel>
    )
  }
}

export default RadioOption
